export default __webpack_public_path__ + "static/media/image-1.ff549ac9.png";